import React from 'react';

const CucumberIcon = () => {
  return <img src='/skill-icons/cucumber.png' alt='cucumber-logo' />;
};

export default CucumberIcon;
